import React from "react";
import { Route, Routes } from "react-router-dom";
import ForgotPassword from "../../../redux/auth/components/ForgotPasswordForm";
import LoginForm from "../../../redux/auth/components/LoginForm";
import VerifyEmail from "../../../redux/auth/components/VerifyEmail";
import ResetPassword from "../../../redux/auth/components/ResetPassword";
import {
  CUSTOMER_REGISTRATION,
  FORGOT_PASSWORD,
  LOGIN,
  PAYMENT_FAILURE,
  PAYMENT_PROCESSING,
  PAYMENT_SUCCESS,
  RESET_PASSWORD,
  VENDOR_REGISTRATION,
  VERIFY_EMAIL,
  VERIFY_OTP
} from "./AppRoutes";
import CustomerRegistration from "../../../Screens/Customer/CustomerRegistration";
import VendorRegistration from "../../../Screens/Vendor/VendorRegistration";
import VerifyOTP from "../../../Screens/Customer/VerifyOTP";

const UnauthenticatedRoutes = () => {
  return (
    <Routes>
      <Route path={LOGIN} element={<LoginForm />} />
      <Route path={FORGOT_PASSWORD} element={<ForgotPassword />} />
      <Route path={VERIFY_EMAIL} element={<VerifyEmail />} />
      <Route path={RESET_PASSWORD} element={<ResetPassword />} />
      <Route path={CUSTOMER_REGISTRATION} element={<CustomerRegistration />} />
      <Route path={VENDOR_REGISTRATION} element={<VendorRegistration />} />
      <Route path={VERIFY_OTP} element={<VerifyOTP />} />
      {/* <Route path={PAYMENT_SUCCESS} element={<PaymentSuccess />} />
      <Route path={PAYMENT_FAILURE} element={<PaymentFailure />} />

      <Route path={PAYMENT_PROCESSING} element={<PaymentProcessingPage />} /> */}
    </Routes>
  );
};

export default UnauthenticatedRoutes;
